import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Environment, EnvironmentService } from '@galaxy/core';

@Injectable({ providedIn: 'root' })
export class SignUpGuard {
  constructor(private environmentService: EnvironmentService) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    let href = '';
    switch (this.environmentService.getEnvironment()) {
      case Environment.PROD: {
        href = 'https://signup.vendasta.com';
        break;
      }
      case Environment.DEMO: {
        href = 'https://partner-demo.vendasta-internal.com/';
        break;
      }
      default: {
        href = 'https://signup.vendasta.com';
        break;
      }
    }

    window.location.href = href;
    return true;
  }
}
